import { ReactNode } from 'react';

import Typography from '@mui/material/Typography';

import { DataTableColumn, SortableType } from './types';

export const normalizeSortableValue = (
  value: SortableType,
): string | number => {
  if (value == null) return '';
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;
  if (typeof value === 'boolean') return value ? 1 : 0;
  return String(value).toLowerCase();
};

export const compareSortableValues = (
  a: string | number,
  b: string | number,
): number => {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }

  return String(a).localeCompare(String(b));
};

export const toCellNode = (value: unknown): ReactNode => {
  if (value === null || value === undefined) {
    return '';
  }

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return String(value);
  }

  return value as ReactNode;
};

export const getCellContent = <TRow extends Record<string, unknown>>(
  row: TRow,
  column: DataTableColumn<TRow>,
) => {
  if (column.render) {
    return column.render(row);
  }

  const key = column.id as keyof TRow;
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ wordBreak: 'break-word' }}
    >
      {toCellNode(row[key])}
    </Typography>
  );
};
